import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPCoursesDatasource } from '../../../../global/datasources/ap_courses_datasource';
import { IAPProgramSlotDatasource } from '../../../../global/datasources/ap_program_slot_datasource';
import { APProgramSlotServant } from '../../../../global/servants/ap_program_slot_servant';
import { LargeCourseGroupSearchResultModel } from '../models/large_course_group_search_result_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'fetchLargeCourseGroupCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngAPCoursesDatasource: IAPCoursesDatasource,
      ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
      ngLargeCourseGroupSearchResultModel: LargeCourseGroupSearchResultModel,
      log: any
    ): ICommand => {
      return defineCommandORM(
        'fetchLargeCourseGroupCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          slot_id: string,
          limit: number,
          offset: number,
          query: string = ''
        ): void => {
          const slot = ngAPProgramSlotDatasource.get(slot_id);
          const url = `/academicplan/course/`;
          let course_group_nk;
          if (slot && APProgramSlotServant.isCourseGroupProgramSlot(slot)) {
            course_group_nk = slot.course_group;
          }
          $http({
            url,
            method: 'GET',
            params: {
              course_group_nk,
              limit,
              offset,
              query
            }
          })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              const programSlotCourses = data.results.map((course: any) => ({ course_id: course.id }));
              ngAPCoursesDatasource.write(data.results);
              const newIds: number[] = [
                ..._4.cloneDeep(ngLargeCourseGroupSearchResultModel.read().ids),
                ..._4.map(data.results, (result: { id: number }) => result['id'])
              ];
              ngLargeCourseGroupSearchResultModel.clear();
              ngLargeCourseGroupSearchResultModel.read().ids = newIds;
              ngLargeCourseGroupSearchResultModel.write({
                ids: newIds,
                count: data.count,
                next: data.next,
                previous: data.previous
              });
              const programSlot = ngAPProgramSlotDatasource.get(slot_id);
              if (programSlot && !APProgramSlotServant.isNCRProgramSlot(programSlot)) {
                programSlot.courses = _4.uniqBy(_4.concat(programSlot.courses || [], programSlotCourses), 'course_id');
                ngAPProgramSlotDatasource.put(programSlot);
              }
              deferred.resolve();
            })
            .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
              log.issue('failed to retrieve info for course');
              deferred.reject(e.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/large_course_group/commands/fetch_large_course_group_command.ts